// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Calendar: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<path d="M22.53,21.48L1.49,21.5V8.59h-1.4V21.5c0,0.76,0.62,1.38,1.38,1.38h21.06c0.76,0,1.38-0.62,1.38-1.38V8.59h-1.4L22.53,21.48
	z"/>
<path d="M3.51,16.04v1.4h0.66v2.02h1.4v-2.02h3.35v2.02h1.4v-2.02h3.35v2.02h1.4v-2.02h3.35v2.02h1.4v-2.02h0.66v-1.4h-0.66v-2.67
	h0.66v-1.4h-0.66v-2.7h-1.4v2.7h-3.35v-2.7h-1.4v2.7h-3.35v-2.7h-1.4v2.7H5.57v-2.7h-1.4v2.7H3.51v1.4h0.66v2.67H3.51z M18.43,13.37
	v2.67h-3.35v-2.67H18.43z M13.68,13.37v2.67h-3.35v-2.67H13.68z M5.57,13.37h3.35v2.67H5.57V13.37z"/>
<path d="M22.7,1.78h-2.89v1.4h2.7v2.68H1.49L1.47,3.18h2.72v-1.4H1.47c-0.76,0-1.38,0.62-1.38,1.38v4.1h23.82v-4.1
	C23.91,2.21,23.3,1.78,22.7,1.78z"/>
<rect x="8.26" y="1.78" width="7.47" height="1.4"/>
<rect x="5.53" y="1.12" width="1.4" height="2.72"/>
<rect x="17.07" y="1.12" width="1.4" height="2.72"/>
</svg>;
};

export default React.memo(Calendar);
